import {axiosFileNodeClient, axiosNodeClient} from "../http";

export const imageServiceNode = {
    getAll,
    upload,
    delete: _delete
}

function getAll({storeId, imgName}) {
    if (storeId && imgName) {
        return axiosNodeClient.get(`/images/${storeId}/${imgName}`);
    }
    if (storeId) {
        return axiosNodeClient.get(`/images/${storeId}`);
    }

}

function upload({storeId, imgFile}) {
    let formData = new FormData();
    formData.append('file', imgFile);

    return axiosFileNodeClient.post('/image/' + storeId, formData);
}

function _delete({storeId, imgName}) {
    return axiosNodeClient.delete(`/images/${storeId}/${imgName}`);
}
